/**
 * The dashboard's percent ring — moved out of `Dashboard.tsx` in V0.50.2 (a move, not a copy)
 * because the Projects tab draws it too, and a tab importing it from the region that mounts
 * the tab would be an import cycle.
 *
 * Circumference of the r=15.9155 circle is ~100, so a dash array reads directly as a percent.
 * `StatusDonut` in `Dashboard.tsx` builds its segments on the same radius.
 */
export const R = 15.9155;

export function Pie({
  pct,
  color,
  size = 64,
  text = true,
}: {
  pct: number;
  color: string;
  /** The Overview's tiles are 64px; the Projects strip draws a 28px one beside each name. */
  size?: number;
  /** The percentage in the middle — off for a ring too small to carry a number. */
  text?: boolean;
}) {
  const dash = Math.max(0, Math.min(100, pct));
  return (
    <svg viewBox="0 0 36 36" width={size} height={size}>
      <circle cx="18" cy="18" r={R} fill="none" stroke="var(--line)" strokeWidth="3.5" />
      <circle
        cx="18"
        cy="18"
        r={R}
        fill="none"
        stroke={color}
        strokeWidth="3.5"
        strokeLinecap="round"
        strokeDasharray={`${dash} ${100 - dash}`}
        strokeDashoffset="25"
        transform="rotate(-90 18 18)"
      />
      {text ? (
        <text x="18" y="20.8" textAnchor="middle" fontSize="7.5" fontWeight="600" fill="var(--ink)">
          {dash}%
        </text>
      ) : null}
    </svg>
  );
}
